import { PT_BR } from "./pt-br";

export const MESSAGES = {
	PT_BR
};